import React from "react";
import {
    CARD_CONTAINER_CLASS,
    IMAGE_CONTAINER_CLASS,
    INNER_CARD_CONTAINER_CLASS,
} from "./Style";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { QOUTES_ICON_TEXT } from "./constants";

const FullyStyleInclusiveCard = ({
    image,
    mobileImage,
    description,
    title,
}) => {
    return (
        <div className={CARD_CONTAINER_CLASS}>
            <img
                src={image?.url}
                className={IMAGE_CONTAINER_CLASS}
                alt={QOUTES_ICON_TEXT}
                id={QOUTES_ICON_TEXT}
                loading="lazy"
            />
            <div className={INNER_CARD_CONTAINER_CLASS}>
                <TypographyMontserrat
                    align={"left"}
                    size={"2xl"}
                    fontWeight={"semibold"}
                    text={title}
                    customStyle={" uppercase "}
                />

                <TypographyMontserrat
                    align={"left"}
                    size={"base"}
                    text={description}
                    customStyle={" uppercase h-16 sm:h-12	lg:h-16 xl:h-12 "}
                />
            </div>
        </div>
    );
};

export default FullyStyleInclusiveCard;
